import { render } from "./IconChevron.vue?vue&type=template&id=22aa7553"
import script from "./IconChevron.vue?vue&type=script&lang=js"
export * from "./IconChevron.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__